import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  Container,
  Center,
  Button,
  Text,
  FormControl,
  FormErrorMessage,
  Input,
  Image,
  IconButton,
  Heading,
  VStack,
  RadioGroup,
  Radio,
  Select,
  HStack,
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import { ColorModeSwitcher } from "../ColorModeSwitcher";
import { Nav } from "../containers/Nav";
import { validateUserAuth } from "../helpers";
import {
  getMovies,
  submitMovieRating,
  getMovieRatings,
} from "../actions/ratings";
import { useNavigate } from "react-router-dom";
import { constants } from "../constants";

function Ratings() {
  const userInfo = validateUserAuth();
  const navigate = useNavigate();
  const lightGray = useColorModeValue("gray.600", "gray.100");

  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  const [movies, setMovies] = useState([]);
  const [selectedMovie, setSelectedMovie] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [movieRated, setMovieRated] = useState(false);
  const [likePercents, setLikePercents] = useState([0, 0]);
  const [noResults, setNoResults] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [dislikeCount, setDislikeCount] = useState(0);

  useEffect(() => {
    // Use a setTimeout to delay the API call by 2000 milliseconds (1.3 seconds)
    const timerId = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 1300);

    // Clear the timeout if the user continues typing within the 1.3-second window
    return () => {
      clearTimeout(timerId);
    };
  }, [inputValue]);

  useEffect(() => {});

  const obtainMovieRatings = (movie) => {
    let likes = 0,
      dislikes = 0;
    getMovieRatings(movie).then((ratings) => {
      setMovieRated(false);
      setLikePercents([0, 0]);
      ratings.map((rating) => {
        if (rating.username === userInfo.email) {
          setMovieRated(true);
        }
        if (rating.rating) {
          likes += 1;
        } else {
          dislikes += 1;
        }
      });
      setLikeCount(likes);
      setDislikeCount(dislikes);

      const total = likes + dislikes;
      const likePercent = parseInt((likes / total) * 100) || 0;
      const dislikePercent = parseInt((dislikes / total) * 100) || 0;
      setLikePercents([likePercent, dislikePercent]);
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      // Perform your API request using debouncedValue
      if (debouncedValue !== "") {
        try {
          const data = await getMovies(debouncedValue);
          if (data?.movies?.length) {
            setMovies(data?.movies);
          } else {
            setNoResults(true);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData(); // Call the API function here
  }, [debouncedValue]);

  const handleInputChange = (event) => {
    setNoResults(false);
    setInputValue(event.target.value);
  };

  const onClose = () => {
    setSelectedMovie({});
    setIsOpen(false);
  };

  const submitRating = async (movie, liked) => {
    let movieId = movie.id;
    let likes = likeCount;
    let dislikes = dislikeCount;

    try {
      const data = await submitMovieRating(movie, Boolean(liked));
      if (data) {
        setMovieRated(true);
        //obtainMovieRatings(movie);
        if (liked) {
          setLikeCount(likeCount + 1);
          likes += 1;
        } else {
          setDislikeCount(dislikeCount + 1);
          dislikes += 1;
        }

        const total = likes + dislikes;
        const likePercent = parseInt((likes / total) * 100) || 0;
        const dislikePercent = parseInt((dislikes / total) * 100) || 0;
        setLikePercents([likePercent, dislikePercent]);
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
    }
  };

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      h="200px"
      color="blackAlpha.700"
    >
      <Nav />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Heading fontSize="xl">Rate this content</Heading>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box>
              {/*<Text fontSize="md">
                Green E is good, red e is bad. Press the image to start
              </Text> */}
            </Box>
            <Center>
              <VStack mt="5">
                <Heading as="h2" fontSize="2xl">
                  {selectedMovie.title || selectedMovie.name}
                </Heading>
                <Image
                  height="300px"
                  src={`https://image.tmdb.org/t/p/w200${selectedMovie.poster_path}`}
                  alt={selectedMovie.title || selectedMovie.title}
                  borderRadius="md"
                  mt={2}
                />
                {Boolean(movieRated) ? (
                  <>
                    <Text as="b" mt="4">
                      You have watched and rated this content!
                    </Text>

                    <HStack spacing="12">
                      <Box>
                        <Center>
                          <VStack spacing="0">
                            <Button
                              isDisabled="true"
                              size="md"
                              fontSize="lg"
                              colorScheme="green"
                              aria-label={`Liked this`}
                              mb="0"
                            >
                              e
                            </Button>
                            <Text opacity=".5" color="green" as="b" mt="0">
                              {likePercents[0]}%
                            </Text>
                          </VStack>
                        </Center>
                      </Box>
                      <Box>
                        <Center>
                          <VStack spacing="0">
                            {/*
                        <IconButton
                          size="md"
                          fontSize="lg"
                          colorScheme="red"
                          aria-label={`I did not liked this`}
                          icon={<FaThumbsDown />}
                          mb="0"
                        />*/}
                            <Button
                              isDisabled="true"
                              size="md"
                              fontSize="lg"
                              colorScheme="red"
                              aria-label={`Did not like this`}
                              mb="0"
                            >
                              e
                            </Button>
                            <Text opacity=".5" color="red" as="b" mt="0">
                              {likePercents[1]}%
                            </Text>
                          </VStack>
                        </Center>
                      </Box>
                    </HStack>
                  </>
                ) : (
                  <>
                    <Text as="b" mt="4">
                      Did you like this content?
                    </Text>
                    <Text mb="4">
                      Green{" "}
                      <Text fontWeight="bold" as="span" color="green">
                        e
                      </Text>{" "}
                      is good, Red{" "}
                      <Text fontWeight="bold" as="span" color="red">
                        e
                      </Text>{" "}
                      is bad.
                    </Text>
                    <HStack spacing="12">
                      <Box>
                        <Center>
                          <VStack spacing="0">
                            <Button
                              size="md"
                              fontSize="lg"
                              colorScheme="green"
                              aria-label={`Liked this`}
                              mb="0"
                              onClick={() => submitRating(selectedMovie, true)}
                            >
                              e
                            </Button>
                            <Text opacity=".5" color="green" as="b" mt="0">
                              {movieRated && likePercents[0] + "%"}
                            </Text>
                          </VStack>
                        </Center>
                      </Box>
                      <Box>
                        <Center>
                          <VStack spacing="0">
                            {/*
                        <IconButton
                          size="md"
                          fontSize="lg"
                          colorScheme="red"
                          aria-label={`I did not liked this`}
                          icon={<FaThumbsDown />}
                          mb="0"
                        />*/}
                            <Button
                              size="md"
                              fontSize="lg"
                              colorScheme="red"
                              aria-label={`Did not like this`}
                              onClick={() => submitRating(selectedMovie, false)}
                              mb="0"
                            >
                              e
                            </Button>
                            <Text opacity=".5" color="red" as="b" mt="0">
                              {movieRated && likePercents[1] + "%"}
                            </Text>
                          </VStack>
                        </Center>
                      </Box>
                    </HStack>
                  </>
                )}
                )}
              </VStack>
            </Center>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>

      <GridItem pl="2" area={"main"}>
        <VStack mt="5">
          <Heading color={lightGray}>Ratings</Heading>
          <Card
            maxWidth="1200px"
            align
            mx="5"
            mb="5"
            p="5"
            bg={useColorModeValue("gray.100", "gray.900")}
          >
            <Box>
              <Text>Look up a movie or tv show to rate</Text>
              <Input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                placeholder="Start typing a movie or tv show title"
              />

              <Box mt={2}>
                {movies.map((movie, i) => (
                  <Link
                    onClick={() => {
                      setIsOpen(true);
                      //getMovieRatings(movie.id);
                      obtainMovieRatings(movie.id);
                      setSelectedMovie(movie);
                    }}
                  >
                    <Text color="teal.500" textDecoration="underline" key={i}>
                      {movie.title || movie.name}
                    </Text>
                  </Link>
                ))}
                {noResults && <Text>No results</Text>}
              </Box>
            </Box>
          </Card>
        </VStack>
      </GridItem>
    </Grid>
  );
}

export default Ratings;
